<template>
  <q-card style="min-width: 350px">
    <q-card-section>
      <div class="text-h6">Randevu Iptal Et</div>
    </q-card-section>

    <q-card-section class="q-pt-none">
      <q-form class="q-gutter-md">
        <!-- Appointment Send E-Mail ? -->
        <q-checkbox
          v-model="appointmentSendEmail"
          label="E-Posta Gonder"
          color="teal"
        />

        <!-- Appointment Send Sms ? -->
        <q-checkbox
          v-model="appointmentSendSms"
          label="SMS Gonder"
          color="teal"
        />
      </q-form>
    </q-card-section>

    <q-card-actions align="right" class="text-primary">
      <q-btn v-close-popup flat label="Vazgec" color="red" />
      <q-btn
        v-close-popup
        flat
        label="Iptal Et"
        color="secondary"
        @click="onSubmit"
      />
    </q-card-actions>
  </q-card>
</template>

<script>
import { useQuasar } from 'quasar'
import { ref, toRefs, inject } from 'vue'
import axios from 'axios'
import * as eventNames from '../../utils/events'
import * as notify from '../../utils/notification'

export default {
  props: {
    appointment: Object,
  },
  setup(props) {
    const $q = useQuasar()
    const emitter = inject('emitter')
    let { appointment } = toRefs(props)

    // appointment cancel form inputs
    const appointmentSendEmail = ref(true)
    const appointmentSendSms = ref(true)

    function prepareRequestPayload() {
      return {        
        sendEmail: appointmentSendEmail.value,
        sendSms: appointmentSendSms.value
      }
    }

    return {      
      appointmentSendEmail,
      appointmentSendSms,
      prepareRequestPayload,
      onSubmit() {
        axios
          .post(
            `/appointments/${appointment.value.id}/cancel?sendEmail=${appointmentSendEmail.value}&sendSms=${appointmentSendSms.value}`)
          .then(() => {
            $q.notify(notify.success('Randevu iptal edildi.'))
            emitter.emit(eventNames.REFRESH_APPOINTMENTS)
          })
          .catch(() => {
            $q.notify(notify.warning('Randevu iptal edilemedi.'))
          })
      },
    }
  },
}
</script>
